/**
 * @file Contains payment method fields util.
 */

export const checkPaymentFieldsContainsFilledFields = (arr, target) => target.every(value => arr.includes(value));
